import { render, staticRenderFns } from "./FissionHistory.vue?vue&type=template&id=b936571c&scoped=true&"
import script from "./FissionHistory.vue?vue&type=script&lang=ts&"
export * from "./FissionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./FissionHistory.vue?vue&type=style&index=0&id=b936571c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b936571c",
  null
  
)

export default component.exports